// // import React, { useState, useEffect } from 'react';
// // import { ChevronDown } from 'lucide-react';

// // const PremiumArchitectureWebsite = () => {
// //   const [scrolled, setScrolled] = useState(false);

// //   useEffect(() => {
// //     const handleScroll = () => {
// //       setScrolled(window.scrollY > 50);
// //     };
// //     window.addEventListener('scroll', handleScroll);
// //     return () => window.removeEventListener('scroll', handleScroll);
// //   }, []);

// //   const stats = [
// //     { number: '250', suffix: '+', text: "We're proud to have the trust of 250 clients." },
// //     { number: '90', suffix: '+', text: 'We have completed over 50 projects in various sectors.' },
// //     { number: '500', suffix: '+', text: 'We have 100 architects and engineers focused on quality.' },
// //     { number: '$5.5', suffix: '+', text: 'We manage projects over 3M, showcasing our skill in design.' }
// //   ];

// //   const projects = [
// //     {
// //       title: 'Modern Loft Design',
// //       location: 'Chicago, Illinois, United States',
// //       image: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800'
// //     },
// //     {
// //       title: 'Modern Loft Design',
// //       location: 'Chicago, Illinois, United States',
// //       image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800'
// //     }
// //   ];

// //   const galleryImages = [
// //     'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=800',
// //     'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800'
// //   ];

// //   return (
// //     <div className="min-h-screen bg-[#f0eae6] font-sans">
// //       {/* Premium Header */}
  

// //       {/* Hero Section - Full Image */}
// //       <section className="relative h-screen w-full overflow-hidden">
// //         <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-transparent z-10"></div>
        
// //         {/* Hero Image */}
// //         <div 
// //           className="absolute inset-0 bg-cover bg-center"
// //           style={{
// //             backgroundImage: `url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920')`,
// //           }}
// //         ></div>

// //         {/* Hero Content */}
// //         <div className="relative z-20 h-full flex items-center justify-center">
// //           <div className="text-center px-6 max-w-4xl mx-auto">
// //             <div className="mb-6 inline-block">
// //               <span className="text-white/90 text-sm uppercase tracking-[0.3em] font-light">
// //                 Architecture & Interior Design
// //               </span>
// //             </div>
// //             <h1 className="text-5xl md:text-7xl lg:text-8xl font-light text-white mb-8 leading-tight">
// //               Creating Spaces<br />
// //               <span className="font-light italic">That Inspire</span>
// //             </h1>
// //             <p className="text-white/80 text-lg md:text-xl mb-12 max-w-2xl mx-auto leading-relaxed">
// //               Transforming visions into architectural masterpieces with precision and creativity
// //             </p>
// //             <button className="group relative bg-white text-gray-900 px-10 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-500 shadow-2xl hover:shadow-3xl transform hover:-translate-y-1 overflow-hidden">
// //               <span className="relative z-10">Explore Our Work</span>
// //               <div className="absolute inset-0 bg-gradient-to-r from-gray-100 to-white transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
// //             </button>
// //           </div>
// //         </div>

// //         {/* Scroll Indicator */}
// //         <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 animate-bounce">
// //           <ChevronDown className="w-8 h-8 text-white/60" />
// //         </div>
// //       </section>

// //       {/* Stats Section */}
// //       <section className="py-20 px-6 bg-white">
// //         <div className="max-w-7xl mx-auto">
// //           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
// //             {stats.map((stat, index) => (
// //               <div 
// //                 key={index}
// //                 className="text-left transform hover:scale-105 transition-all duration-500 group"
// //               >
// //                 <div className="mb-4 overflow-hidden">
// //                   <h3 className="text-5xl md:text-6xl font-light text-gray-900 group-hover:translate-x-2 transition-transform duration-500">
// //                     {stat.number}
// //                     <span className="text-4xl align-top">{stat.suffix}</span>
// //                   </h3>
// //                 </div>
// //                 <p className="text-gray-600 leading-relaxed text-base">
// //                   {stat.text}
// //                 </p>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* Large Image Section */}
// //       <section className="relative h-[70vh] overflow-hidden">
// //         <div 
// //           className="absolute inset-0 bg-cover bg-center"
// //           style={{
// //             backgroundImage: `url('https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=1920')`,
// //           }}
// //         ></div>
// //         <div className="absolute inset-0 bg-gradient-to-t from-[#f0eae6] via-transparent to-transparent"></div>
// //       </section>

// //       {/* Gallery Grid Section */}
// //       <section className="py-20 px-6 bg-black">
// //         <div className="max-w-7xl mx-auto">
// //           <div className="text-center mb-16">
// //             <button className="bg-white text-black px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-300 mb-12">
// //               Learn More
// //             </button>
// //           </div>
          
// //           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
// //             {galleryImages.map((image, index) => (
// //               <div 
// //                 key={index}
// //                 className="relative h-[500px] overflow-hidden rounded-lg group cursor-pointer"
// //               >
// //                 <img 
// //                   src={image} 
// //                   alt={`Gallery ${index + 1}`}
// //                   className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
// //                 />
// //                 <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* Projects Grid Section */}
// //       <section className="py-20 px-6 bg-white">
// //         <div className="max-w-7xl mx-auto">
// //           <button className="bg-black text-white px-8 py-3 rounded-lg font-semibold hover:bg-gray-900 transition-all duration-300 mb-16">
// //             Learn More
// //           </button>
          
// //           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
// //             {projects.map((project, index) => (
// //               <div 
// //                 key={index}
// //                 className="group cursor-pointer"
// //               >
// //                 <div className="relative h-[500px] overflow-hidden rounded-lg mb-6">
// //                   <img 
// //                     src={project.image} 
// //                     alt={project.title}
// //                     className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
// //                   />
// //                   <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
// //                 </div>
// //                 <h3 className="text-2xl font-light text-gray-900 mb-2 group-hover:text-gray-600 transition-colors duration-300">
// //                   {project.title}
// //                 </h3>
// //                 <div className="flex items-center justify-between text-gray-600">
// //                   <span className="text-sm">{project.location}</span>
// //                   <span className="text-sm">Location</span>
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* CTA Split Section */}
// //       <section className="relative h-screen">
// //         <div className="grid grid-cols-1 md:grid-cols-2 h-full">
// //           {/* Left CTA */}
// //           <div className="relative overflow-hidden group">
// //             <div 
// //               className="absolute inset-0 bg-cover bg-center transform group-hover:scale-110 transition-transform duration-700"
// //               style={{
// //                 backgroundImage: `url('https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800')`
// //               }}
// //             ></div>
// //             <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-colors duration-500"></div>
// //             <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-8">
// //               <span className="text-white/80 text-sm uppercase tracking-widest mb-6">Our Project</span>
// //               <h2 className="text-5xl md:text-6xl font-light text-white mb-4 leading-tight">
// //                 Your idea<br />our expertise
// //               </h2>
// //               <button className="mt-8 bg-white text-black px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-300 transform hover:-translate-y-1 shadow-xl">
// //                 See Explore Our Services
// //               </button>
// //             </div>
// //           </div>

// //           {/* Right CTA */}
// //           <div className="relative overflow-hidden group">
// //             <div 
// //               className="absolute inset-0 bg-cover bg-center transform group-hover:scale-110 transition-transform duration-700"
// //               style={{
// //                 backgroundImage: `url('https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800')`
// //               }}
// //             ></div>
// //             <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-colors duration-500"></div>
// //             <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-8">
// //               <span className="text-white/80 text-sm uppercase tracking-widest mb-6">Contact Us</span>
// //               <h2 className="text-5xl md:text-6xl font-light text-white mb-4 leading-tight">
// //                 Let's begin<br />in the experience
// //               </h2>
// //               <button className="mt-8 bg-white text-black px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-300 transform hover:-translate-y-1 shadow-xl">
// //                 Get in touch
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       </section>
// //     </div>
// //   );
// // };

// // export default PremiumArchitectureWebsite;

// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { 
//   ChevronDown, 
//   ChevronLeft, 
//   ChevronRight,
//   Building2,
//   Award,
//   Users,
//   TrendingUp,
//   Phone,
//   Mail,
//   MapPin,
//   X,
//   ArrowRight,
//   Star,
//   CheckCircle
// } from 'lucide-react';
// import srinivas from  './Images/1-FRONT-1-scaled-1.jpg';
// import garudadri from  './Images/garuda.png';
// import post1 from './Images/vedamsa-post-10.png';
// import post2 from './Images/Poster-2.png';

// const HomePage = () => {
//   const [scrolled, setScrolled] = useState(false);
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [showPopup, setShowPopup] = useState(false);
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: ''
//   });

//   const heroSlides = [
//     {
//       image: srinivas,
//       title: 'Creating Spaces',
//       subtitle: 'That Inspire',
//       description: 'Transforming visions into architectural masterpieces with precision and creativity'
//     },
//     {
//       image: garudadri,
//       title: 'Building Dreams',
//       subtitle: 'Creating Futures',
//       description: '30 years of excellence in Hyderabad real estate with over 3000 happy customers'
//     }
//   ];


//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Auto-slide hero
//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentSlide((prev) => (prev === heroSlides.length - 1 ? 0 : prev + 1));
//     }, 5000);
//     return () => clearInterval(timer);
//   }, []);

//   // Show popup after 3 seconds
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShowPopup(true);
//     }, 3000);
//     return () => clearTimeout(timer);
//   }, []);

//   const handlePrevSlide = () => {
//     setCurrentSlide((prev) => (prev === 0 ? heroSlides.length - 1 : prev - 1));
//   };

//   const handleNextSlide = () => {
//     setCurrentSlide((prev) => (prev === heroSlides.length - 1 ? 0 : prev + 1));
//   };

//   const handleFormChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleFormSubmit = (e) => {
//     e.preventDefault();
//     console.log('Form submitted:', formData);
//     alert('Thank you! We will contact you soon.');
//     setShowPopup(false);
//     setFormData({ name: '', email: '', phone: '' });
//   };

//   const stats = [
//     { number: '30+', text: 'Years of Experience' },
//     { number: '70+', text: 'Projects Completed' },
//     { number: '3,000+', text: 'Happy Customers' },
//     { number: '2', text: 'Upcoming Projects' }
//   ];

//   const coreValues = [
//     {
//       icon: <Award className="w-8 h-8" />,
//       title: 'Quality',
//       description: 'We use the finest materials and employ stringent quality control measures to ensure that every project we undertake meets the highest standards of excellence.'
//     },
//     {
//       icon: <TrendingUp className="w-8 h-8" />,
//       title: 'Innovation',
//       description: 'We embrace new technologies and innovative construction methods to deliver projects that are aesthetically pleasing but also sustainable and durable.'
//     },
//     {
//       icon: <CheckCircle className="w-8 h-8" />,
//       title: 'Transparency',
//       description: 'We maintain open and honest communication with our clients, ensuring they are informed and involved at every stage of the construction process.'
//     }
//   ];

//   const testimonials = [
//     {
//       name: 'Suresh Varma',
//       role: 'Builder',
//       text: 'Vedamsa exceeded our expectations in every way. Their projects are best in quality and delivered on time',
//       rating: 5
//     },
//     {
//       name: 'Venkat Chowdary',
//       role: 'Developer',
//       text: 'Choosing Vedamsa for our new apartment was the best decision we made. Their sales team is very supportive and helpful.',
//       rating: 5
//     },
//     {
//       name: 'Supriya',
//       role: 'IT Employee',
//       text: 'The experience with Vedamsa has been exceptional. Their commitment to quality and customer satisfaction is evident in every aspect of their work.',
//       rating: 5
//     }
//   ];

//   return (
//     <div className="min-h-screen bg-[#f5f3f0]">
//       {/* Popup Form */}
//       {showPopup && (
//         <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4 animate-fade-in">
//           <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 relative animate-scale-in">
//             {/* Close Button */}
//             <button
//               onClick={() => setShowPopup(false)}
//               className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors duration-300"
//             >
//               <X className="w-5 h-5 text-gray-600" />
//             </button>

//             {/* Popup Content */}
//             <div className="text-center mb-6">
//               <div className="w-16 h-16 bg-[#8B7355] rounded-full flex items-center justify-center mx-auto mb-4">
//                 <Building2 className="w-8 h-8 text-white" />
//               </div>
//               <h3 className="text-2xl font-bold text-gray-900 mb-2">Get Exclusive Updates!</h3>
//               <p className="text-gray-600">Be the first to know about our latest projects and offers</p>
//             </div>

//             <form onSubmit={handleFormSubmit} className="space-y-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">Full Name *</label>
//                 <input
//                   type="text"
//                   name="name"
//                   value={formData.name}
//                   onChange={handleFormChange}
//                   required
//                   placeholder="Enter your name"
//                   className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8B7355] focus:border-transparent outline-none transition-all duration-300"
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">Email Address *</label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleFormChange}
//                   required
//                   placeholder="Enter your email"
//                   className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8B7355] focus:border-transparent outline-none transition-all duration-300"
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number *</label>
//                 <input
//                   type="tel"
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleFormChange}
//                   required
//                   placeholder="Enter your phone number"
//                   pattern="[0-9]{10}"
//                   className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8B7355] focus:border-transparent outline-none transition-all duration-300"
//                 />
//               </div>

//               <button
//                 type="submit"
//                 className="w-full bg-[#8B7355] text-white px-6 py-4 rounded-lg font-bold hover:bg-[#6B5744] transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
//               >
//                 Get Started
//               </button>

//               <p className="text-xs text-gray-500 text-center">
//                 We respect your privacy. Your information is safe with us.
//               </p>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Hero Section with Auto-Sliding Images */}
//     {/* Hero Section with Auto-Sliding Images */}
// <section className="relative h-[calc(100vh+200px)] md:h-[calc(100vh+300px)] w-full overflow-hidden">
//   {/* Slides */}
//   {heroSlides.map((slide, index) => (
//     <div
//       key={index}
//       className={`absolute inset-0 transition-opacity duration-1000 ${
//         index === currentSlide ? 'opacity-100' : 'opacity-0'
//       }`}
//     >
//       <div 
//         className="absolute inset-0 bg-cover bg-center bg-no-repeat"
//         style={{
//           backgroundImage: `url('${slide.image}')`,
//           backgroundPosition: 'center top', // Changed to show top of image
//         }}
//       ></div>
//       <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      
//       {/* Content */}
//       <div className="relative z-20 h-full flex items-center justify-center pt-20">
//         <div className="text-center px-6 max-w-4xl mx-auto">
//           <div className="mb-6 inline-block animate-fade-in-down">
//             <span className="text-white/90 text-sm uppercase tracking-[0.3em] font-light">
//               Vedamsa Infrastructure
//             </span>
//           </div>
//           <h1 className="text-5xl md:text-7xl lg:text-8xl font-light text-white mb-4 leading-tight animate-fade-in-up">
//             {slide.title}<br />
//             <span className="font-light italic">{slide.subtitle}</span>
//           </h1>
//           <p className="text-white/80 text-lg md:text-xl mb-12 max-w-2xl mx-auto leading-relaxed animate-fade-in">
//             {slide.description}
//           </p>
//           <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up">
//             <Link 
//               to="/Projects/srinivas"
//               className="bg-white text-gray-900 px-10 py-4 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:-translate-y-1"
//             >
//               Explore Projects
//             </Link>
//             <Link 
//               to="/contact"
//               className="bg-transparent border-2 border-white text-white px-10 py-4 rounded-lg font-bold hover:bg-white hover:text-gray-900 transition-all duration-300"
//             >
//               Contact Us
//             </Link>
//           </div>
//         </div>
//       </div>
//     </div>
//   ))}

//   {/* Navigation Arrows */}
//   <button
//     onClick={handlePrevSlide}
//     className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 z-30 w-12 h-12 bg-white/20 backdrop-blur-sm hover:bg-white/30 rounded-full flex items-center justify-center transition-all duration-300 group"
//   >
//     <ChevronLeft className="w-6 h-6 text-white group-hover:scale-110 transition-transform duration-300" />
//   </button>
//   <button
//     onClick={handleNextSlide}
//     className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 z-30 w-12 h-12 bg-white/20 backdrop-blur-sm hover:bg-white/30 rounded-full flex items-center justify-center transition-all duration-300 group"
//   >
//     <ChevronRight className="w-6 h-6 text-white group-hover:scale-110 transition-transform duration-300" />
//   </button>

//   {/* Slide Indicators */}
//   <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-30 flex space-x-2">
//     {heroSlides.map((_, index) => (
//       <button
//         key={index}
//         onClick={() => setCurrentSlide(index)}
//         className={`w-2 h-2 rounded-full transition-all duration-300 ${
//           index === currentSlide ? 'bg-white w-8' : 'bg-white/50'
//         }`}
//       />
//     ))}
//   </div>

//   {/* Scroll Indicator */}
//   <div className="absolute bottom-20 left-1/2 -translate-x-1/2 z-20 animate-bounce">
//     <ChevronDown className="w-8 h-8 text-white/60" />
//   </div>
// </section>

//       {/* Who We Are Section */}
//       <section className="py-20 px-6 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [WHO WE ARE]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               Welcome to Vedamsa
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed max-w-4xl mx-auto">
//               A premier construction company in Hyderabad with a nearly 30-year legacy of excellence and trust. Over this period, Vedamsa has become synonymous with quality, reliability, and customer satisfaction in plotting and construction. With an impressive portfolio and a track record of over 3000 happy customers, we stand as a testament to what dedication, expertise, and commitment can achieve.
//             </p>
//           </div>

//           {/* Core Values */}
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
//             {coreValues.map((value, index) => (
//               <div 
//                 key={index}
//                 className="bg-[#f5f3f0] p-8 rounded-xl hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
//               >
//                 <div className="w-16 h-16 bg-[#8B7355] text-white rounded-xl flex items-center justify-center mb-4">
//                   {value.icon}
//                 </div>
//                 <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
//                 <p className="text-gray-600 leading-relaxed">{value.description}</p>
//               </div>
//             ))}
//           </div>

//           <div className="text-center">
//             <Link 
//               to="/about"
//               className="inline-flex items-center space-x-2 bg-[#8B7355] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#6B5744] transition-all duration-300 shadow-lg hover:shadow-xl"
//             >
//               <span>Know More</span>
//               <ArrowRight className="w-5 h-5" />
//             </Link>
//           </div>
//         </div>
//       </section>

//       {/* Projects Section */}
//       <section className="py-20 px-6 bg-[#f5f3f0]">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [OUR PROJECTS]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               Creating Environments that<br />Inspire and Delight
//             </h2>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             {/* MAA Srinivasam */}
//             <Link 
//               to="/Projects/srinivas"
//               className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500"
//             >
//               <div className="relative h-[600px] overflow-hidden">
//                 <img 
//                   src={post2}
//                   alt="MAA Srinivasam"
//                   className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
//               </div>
              
//               <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
//                 <span className="text-sm uppercase tracking-wider text-white/80 mb-2 block">Luxury Apartments</span>
//                 <h3 className="text-3xl md:text-4xl font-bold mb-3">MAA Srinivasam</h3>
//                 <p className="text-white/90 mb-4">Gated Community Apartment Project</p>
//                 <p className="text-white/80 mb-6">2 & 3 BHK Premium Apartments in Isnapur, Mumbai Highway</p>
//                 <div className="inline-flex items-center space-x-2 bg-white text-gray-900 px-6 py-3 rounded-lg font-semibold group-hover:bg-[#8B7355] group-hover:text-white transition-all duration-300">
//                   <span>View Project</span>
//                   <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
//                 </div>
//               </div>
//             </Link>

//             {/* MAA Garudadri */}
//             <Link 
//               to="/Projects/garudadri"
//               className="group relative overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500"
//             >
//               <div className="relative h-[600px] overflow-hidden">
//                 <img 
//                   src={post1}
//                   alt="MAA Garudadri"
//                   className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
//               </div>
              
//               <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
//                 <span className="text-sm uppercase tracking-wider text-white/80 mb-2 block">Villa Plots</span>
//                 <h3 className="text-3xl md:text-4xl font-bold mb-3">MAA Garudadri</h3>
//                 <p className="text-white/90 mb-4">Villa and Open Plot Project</p>
//                 <p className="text-white/80 mb-6">Premium Villa Plots in Dandupally, Nagpur Highway</p>
//                 <div className="inline-flex items-center space-x-2 bg-white text-gray-900 px-6 py-3 rounded-lg font-semibold group-hover:bg-[#2C5F2D] group-hover:text-white transition-all duration-300">
//                   <span>View Project</span>
//                   <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
//                 </div>
//               </div>
//             </Link>
//           </div>
//         </div>
//       </section>

//       {/* Stats Section */}
//       <section className="py-20 px-6 bg-gray-900 text-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <h2 className="text-4xl md:text-5xl font-bold mb-6">
//               Design A Dynamic Future
//             </h2>
//             <p className="text-gray-300 text-lg">Experience Excellence</p>
//           </div>

//           <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
//             {stats.map((stat, index) => (
//               <div 
//                 key={index}
//                 className="text-center transform hover:scale-105 transition-all duration-300"
//               >
//                 <div className="text-5xl md:text-6xl font-bold mb-2 text-[#8B7355]">
//                   {stat.number}
//                 </div>
//                 <div className="text-gray-400">{stat.text}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Testimonials Section */}
//       <section className="py-20 px-6 bg-white">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-medium mb-6 block">
//               [TESTIMONIALS]
//             </span>
//             <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
//               What People Say
//             </h2>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             {testimonials.map((testimonial, index) => (
//               <div 
//                 key={index}
//                 className="bg-[#f5f3f0] p-8 rounded-xl hover:shadow-xl transition-all duration-300"
//               >
//                 <div className="flex mb-4">
//                   {[...Array(testimonial.rating)].map((_, i) => (
//                     <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
//                   ))}
//                 </div>
//                 <p className="text-gray-700 leading-relaxed mb-6 italic">"{testimonial.text}"</p>
//                 <div>
//                   <p className="font-bold text-gray-900">{testimonial.name}</p>
//                   <p className="text-sm text-gray-600">{testimonial.role}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="relative py-32 px-6 overflow-hidden">
//         <div 
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage: `url('https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1920')`,
//           }}
//         ></div>
//         <div className="absolute inset-0 bg-gradient-to-r from-[#8B7355]/95 to-[#6B5744]/90"></div>

//         <div className="relative z-10 max-w-4xl mx-auto text-center text-white">
//           <h2 className="text-4xl md:text-6xl font-bold mb-6">
//             Book Your Dream Home
//           </h2>
//           <p className="text-xl text-white/90 mb-12">
//             Find the perfect place to call home! Reserve your dream home now and step into a life of comfort, luxury, and style.
//           </p>

//           <Link 
//             to="/contact"
//             className="inline-flex items-center space-x-2 bg-white text-gray-900 px-10 py-5 rounded-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-2xl hover:shadow-3xl transform hover:-translate-y-1 text-lg"
//           >
//             <span>Contact Us</span>
//             <ArrowRight className="w-6 h-6" />
//           </Link>

//           <div className="mt-12 pt-12 border-t border-white/30">
//             <div className="flex flex-col sm:flex-row gap-6 justify-center text-white">
//               <a href="tel:8885852266" className="flex items-center justify-center space-x-2 hover:text-white/80 transition-colors">
//                 <Phone className="w-5 h-5" />
//                 <span>8885852266</span>
//               </a>
//               <a href="mailto:Vedamsa@gmail.com" className="flex items-center justify-center space-x-2 hover:text-white/80 transition-colors">
//                 <Mail className="w-5 h-5" />
//                 <span>Vedamsa@gmail.com</span>
//               </a>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="bg-[#2d1f10] text-white py-12 px-6">
//         <div className="max-w-7xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
//             <div>
//               <div className="flex items-center space-x-3 mb-4">
//                 <div className="bg-white text-gray-900 p-2 rounded">
//                   <Building2 className="w-6 h-6" />
//                 </div>
//                 <span className="text-2xl font-bold">Vedamsa</span>
//               </div>
//               <p className="text-gray-400 mb-4">Building Dreams, Creating Futures</p>
//               <p className="text-gray-500 text-sm">Turn your dream of owning a home into reality with Vedamsa Infra</p>
//             </div>

//             <div>
//               <h4 className="font-bold mb-4">Quick Links</h4>
//               <div className="space-y-2 text-gray-400">
//                 <Link to="/" className="block hover:text-white transition-colors">Home</Link>
//                 <Link to="/about" className="block hover:text-white transition-colors">About</Link>
//                 <Link to="/maa-srinivasam" className="block hover:text-white transition-colors">MAA Srinivasam</Link>
//                 <Link to="/maa-garudadri" className="block hover:text-white transition-colors">MAA Garudadri</Link>
//                 <Link to="/contact" className="block hover:text-white transition-colors">Contact</Link>
//               </div>
//             </div>

//             <div>
//               <h4 className="font-bold mb-4">Contact</h4>
//               <div className="space-y-2 text-gray-400">
//                 <p>Hyderabad, Telangana</p>
//                 <p>Phone: 8885852266</p>
//                 <p>Email: Vedamsa@gmail.com</p>
//               </div>
//             </div>
//           </div>

//           <div className="border-t border-gray-700 pt-8 text-center">
//             <p className="text-gray-500 text-sm">Copyright © 2025 Vedamsa. All rights reserved.</p>
//           </div>
//         </div>
//       </footer>

//       <style jsx>{`
//         @keyframes fade-in {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }
//         @keyframes scale-in {
//           from { transform: scale(0.9); opacity: 0; }
//           to { transform: scale(1); opacity: 1; }
//         }
//         @keyframes fade-in-down {
//           from { opacity: 0; transform: translateY(-20px); }
//           to { opacity: 1; transform: translateY(0); }
//         }
//         @keyframes fade-in-up {
//           from { opacity: 0; transform: translateY(20px); }
//           to { opacity: 1; transform: translateY(0); }
//         }
//         .animate-fade-in { animation: fade-in 0.3s ease-out; }
//         .animate-scale-in { animation: scale-in 0.3s ease-out; }
//         .animate-fade-in-down { animation: fade-in-down 1s ease-out; }
//         .animate-fade-in-up { animation: fade-in-up 1s ease-out 0.3s forwards; opacity: 0; }
//       `}</style>
//     </div>
//   );
// };

// export default HomePage;

// import React, { useState, useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import { 
//   ChevronDown, 
//   ChevronLeft, 
//   ChevronRight,
//   Building2,
//   Award,
//   TrendingUp,
//   Phone,
//   Mail,
//   X,
//   ArrowRight,
//   Star,
//   CheckCircle
// } from 'lucide-react';
// import srinivas from  './Images/1-FRONT-1-scaled-1.jpg';
// import garudadri from  './Images/garuda.png';
// import post1 from './Images/vedamsa-post-10.png';
// import post2 from './Images/Poster-2.png';

// // PURE SILVER Reveal Image Component
// const RevealImage = ({ src, alt, className = "" }) => {
//   const wrapperRef = useRef();
//   const [isRevealed, setIsRevealed] = useState(false);

//   useEffect(() => {
//     const el = wrapperRef.current;
//     const observer = new IntersectionObserver(
//       entries => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting) {
//             setIsRevealed(true);
//             observer.unobserve(el);
//           }
//         });
//       },
//       { threshold: 0.2 }
//     );
//     if (el) observer.observe(el);
//     return () => {
//       if (el) observer.unobserve(el);
//     };
//   }, []);
  
//   return (
//     <div ref={wrapperRef} className={`relative overflow-hidden ${className}`}>
//       <img 
//         src={src} 
//         alt={alt} 
//         className={`w-full h-full object-cover relative z-[1] transition-all duration-[1500ms] ease-out ${
//           isRevealed ? 'opacity-100 scale-100 blur-0' : 'opacity-0 scale-110 blur-sm'
//         }`}
//         style={{ transitionDelay: '800ms' }}
//       />
      
//       {/* PURE SILVER Gradient Mask */}
//       <div 
//         className={`absolute top-0 left-0 w-full h-full z-[2] transition-transform duration-[1500ms] ${
//           isRevealed ? 'scale-x-0 origin-right' : 'scale-x-100 origin-left'
//         }`}
//         style={{ 
//           transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)',
//           background: 'linear-gradient(90deg, #C0C0C0 0%, #E8E8E8 25%, #FFFFFF 50%, #E8E8E8 75%, #C0C0C0 100%)'
//         }}
//       />
      
//       {/* Silver Shimmer */}
//       <div 
//         className={`absolute top-0 left-0 w-full h-full z-[3] transition-all duration-[1500ms] ${
//           isRevealed ? 'opacity-0 translate-x-full' : 'opacity-100 translate-x-0'
//         }`}
//         style={{ 
//           transitionDelay: '300ms',
//           background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.8) 50%, transparent 100%)',
//           transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)'
//         }}
//       />
//     </div>
//   );
// };

// const RevealContent = ({ children, className = "", delay = 0, direction = 'up' }) => {
//   const contentRef = useRef();
//   const [isRevealed, setIsRevealed] = useState(false);

//   useEffect(() => {
//     const el = contentRef.current;
//     const observer = new IntersectionObserver(
//       entries => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting) {
//             setTimeout(() => {
//               setIsRevealed(true);
//             }, delay);
//             observer.unobserve(el);
//           }
//         });
//       },
//       { threshold: 0.15 }
//     );
//     if (el) observer.observe(el);
//     return () => {
//       if (el) observer.unobserve(el);
//     };
//   }, [delay]);
  
//   const getTransform = () => {
//     if (direction === 'up') return isRevealed ? 'translate-y-0' : 'translate-y-[60px]';
//     if (direction === 'down') return isRevealed ? 'translate-y-0' : '-translate-y-[60px]';
//     if (direction === 'left') return isRevealed ? 'translate-x-0' : 'translate-x-[60px]';
//     if (direction === 'right') return isRevealed ? 'translate-x-0' : '-translate-x-[60px]';
//     return '';
//   };
  
//   return (
//     <div 
//       ref={contentRef} 
//       className={`transition-all duration-1000 ${
//         isRevealed ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
//       } ${getTransform()} ${className}`}
//       style={{ transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)' }}
//     >
//       {children}
//     </div>
//   );
// };

// const HomePage = () => {
//   const [scrolled, setScrolled] = useState(false);
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [showPopup, setShowPopup] = useState(false);
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: ''
//   });

//   const heroSlides = [
//     {
//       image: srinivas,
//       title: 'Creating Spaces',
//       subtitle: 'That Inspire',
//       description: 'Transforming visions into architectural masterpieces with precision and creativity'
//     },
//     {
//       image: garudadri,
//       title: 'Building Dreams',
//       subtitle: 'Creating Futures',
//       description: '30 years of excellence in Hyderabad real estate with over 3000 happy customers'
//     }
//   ];

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentSlide((prev) => (prev === heroSlides.length - 1 ? 0 : prev + 1));
//     }, 6000);
//     return () => clearInterval(timer);
//   }, []);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShowPopup(true);
//     }, 3000);
//     return () => clearTimeout(timer);
//   }, []);

//   const handlePrevSlide = () => {
//     setCurrentSlide((prev) => (prev === 0 ? heroSlides.length - 1 : prev - 1));
//   };

//   const handleNextSlide = () => {
//     setCurrentSlide((prev) => (prev === heroSlides.length - 1 ? 0 : prev + 1));
//   };

//   const handleFormChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleFormSubmit = (e) => {
//     e.preventDefault();
//     console.log('Form submitted:', formData);
//     alert('Thank you! We will contact you soon.');
//     setShowPopup(false);
//     setFormData({ name: '', email: '', phone: '' });
//   };

//   const stats = [
//     { number: '30+', text: 'Years of Experience' },
//     { number: '70+', text: 'Projects Completed' },
//     { number: '3,000+', text: 'Happy Customers' },
//     { number: '2', text: 'Upcoming Projects' }
//   ];

//   const coreValues = [
//     {
//       icon: <Award className="w-8 h-8" />,
//       title: 'Quality',
//       description: 'We use the finest materials and employ stringent quality control measures to ensure that every project we undertake meets the highest standards of excellence.'
//     },
//     {
//       icon: <TrendingUp className="w-8 h-8" />,
//       title: 'Innovation',
//       description: 'We embrace new technologies and innovative construction methods to deliver projects that are aesthetically pleasing but also sustainable and durable.'
//     },
//     {
//       icon: <CheckCircle className="w-8 h-8" />,
//       title: 'Transparency',
//       description: 'We maintain open and honest communication with our clients, ensuring they are informed and involved at every stage of the construction process.'
//     }
//   ];

//   const testimonials = [
//     {
//       name: 'Suresh Varma',
//       role: 'Builder',
//       text: 'Vedamsa exceeded our expectations in every way. Their projects are best in quality and delivered on time',
//       rating: 5
//     },
//     {
//       name: 'Venkat Chowdary',
//       role: 'Developer',
//       text: 'Choosing Vedamsa for our new apartment was the best decision we made. Their sales team is very supportive and helpful.',
//       rating: 5
//     },
//     {
//       name: 'Supriya',
//       role: 'IT Employee',
//       text: 'The experience with Vedamsa has been exceptional. Their commitment to quality and customer satisfaction is evident in every aspect of their work.',
//       rating: 5
//     }
//   ];

//   return (
//     <div className="min-h-screen bg-[#f5f3f0] overflow-x-hidden">
//       {/* Popup Form */}
//       {showPopup && (
//         <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 backdrop-blur-md px-4">
//           <div 
//             className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-6 sm:p-8 relative transform transition-all duration-700 ease-out"
//             style={{
//               animation: 'popupEntrance 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) forwards'
//             }}
//           >
//             <button
//               onClick={() => setShowPopup(false)}
//               className="absolute top-3 right-3 sm:top-4 sm:right-4 w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-all duration-300 hover:rotate-90 group"
//             >
//               <X className="w-5 h-5 text-gray-600 group-hover:text-gray-900" />
//             </button>

//             <div className="text-center mb-6">
//               <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-[#8B7355] to-[#6B5744] rounded-full flex items-center justify-center mx-auto mb-4 shadow-xl transform hover:scale-110 transition-transform duration-300">
//                 <Building2 className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
//               </div>
//               <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2 bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">
//                 Get Exclusive Updates!
//               </h3>
//               <p className="text-sm sm:text-base text-gray-600">Be the first to know about our latest projects and offers</p>
//             </div>

//             <form onSubmit={handleFormSubmit} className="space-y-4">
//               <div className="group">
//                 <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">Full Name *</label>
//                 <input
//                   type="text"
//                   name="name"
//                   value={formData.name}
//                   onChange={handleFormChange}
//                   required
//                   placeholder="Enter your name"
//                   className="w-full px-4 py-3 text-sm sm:text-base border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-[#8B7355] focus:border-[#8B7355] outline-none transition-all duration-300 hover:border-[#8B7355]/50"
//                 />
//               </div>

//               <div className="group">
//                 <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">Email Address *</label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleFormChange}
//                   required
//                   placeholder="Enter your email"
//                   className="w-full px-4 py-3 text-sm sm:text-base border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-[#8B7355] focus:border-[#8B7355] outline-none transition-all duration-300 hover:border-[#8B7355]/50"
//                 />
//               </div>

//               <div className="group">
//                 <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">Phone Number *</label>
//                 <input
//                   type="tel"
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleFormChange}
//                   required
//                   placeholder="Enter your phone number"
//                   pattern="[0-9]{10}"
//                   className="w-full px-4 py-3 text-sm sm:text-base border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-[#8B7355] focus:border-[#8B7355] outline-none transition-all duration-300 hover:border-[#8B7355]/50"
//                 />
//               </div>

//               <button
//                 type="submit"
//                 className="w-full bg-gradient-to-r from-[#8B7355] to-[#6B5744] text-white px-6 py-4 rounded-xl font-bold hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-[1.02] relative overflow-hidden group"
//               >
//                 <span className="relative z-10">Get Started</span>
//                 <div className="absolute inset-0 bg-gradient-to-r from-[#6B5744] to-[#8B7355] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
//               </button>

//               <p className="text-xs text-gray-500 text-center">
//                 We respect your privacy. Your information is safe with us.
//               </p>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Hero Section */}
//       <section className="relative h-screen w-full overflow-hidden">
//         {heroSlides.map((slide, index) => (
//           <div
//             key={index}
//             className={`absolute inset-0 transition-all duration-[2000ms] ease-in-out ${
//               index === currentSlide ? 'opacity-100 scale-100' : 'opacity-0 scale-105'
//             }`}
//           >
//             <div 
//               className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-[8000ms] ease-out"
//               style={{
//                 backgroundImage: `url('${slide.image}')`,
//                 backgroundPosition: 'center top',
//                 transform: index === currentSlide ? 'scale(1.1)' : 'scale(1)',
//               }}
//             ></div>
//             <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
            
//             <div 
//               className="absolute inset-0 opacity-10"
//               style={{
//                 backgroundImage: 'radial-gradient(circle at 20% 50%, white 1px, transparent 1px), radial-gradient(circle at 80% 80%, white 1px, transparent 1px)',
//                 backgroundSize: '50px 50px',
//                 animation: 'movePattern 20s linear infinite'
//               }}
//             ></div>
            
//             <div className="relative z-20 h-full flex items-center justify-center pt-16 sm:pt-20">
//               <div className="text-center px-4 sm:px-6 max-w-5xl mx-auto">
//                 <div 
//                   className="mb-6 inline-block"
//                   style={{
//                     animation: index === currentSlide ? 'fadeSlideDown 1.2s cubic-bezier(0.4, 0, 0.2, 1) forwards' : 'none',
//                     opacity: 0
//                   }}
//                 >
//                   <span className="text-white/90 text-xs sm:text-sm uppercase tracking-[0.3em] font-light border border-white/30 px-6 py-2 rounded-full backdrop-blur-sm">
//                     Vedamsa Infrastructure
//                   </span>
//                 </div>
                
//                 <h1 
//                   className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl font-light text-white mb-4 leading-tight"
//                   style={{
//                     animation: index === currentSlide ? 'fadeSlideUp 1.4s cubic-bezier(0.4, 0, 0.2, 1) 0.2s forwards' : 'none',
//                     opacity: 0,
//                     textShadow: '0 10px 30px rgba(0,0,0,0.5)'
//                   }}
//                 >
//                   {slide.title}<br />
//                   <span className="font-light italic bg-clip-text text-transparent bg-gradient-to-r from-white via-gray-200 to-white">
//                     {slide.subtitle}
//                   </span>
//                 </h1>
                
//                 <p 
//                   className="text-white/90 text-lg sm:text-xl md:text-2xl mb-12 max-w-3xl mx-auto leading-relaxed px-4"
//                   style={{
//                     animation: index === currentSlide ? 'fadeSlideUp 1.6s cubic-bezier(0.4, 0, 0.2, 1) 0.4s forwards' : 'none',
//                     opacity: 0
//                   }}
//                 >
//                   {slide.description}
//                 </p>
                
//                 <div 
//                   className="flex flex-col sm:flex-row gap-4 justify-center px-4"
//                   style={{
//                     animation: index === currentSlide ? 'fadeSlideUp 1.8s cubic-bezier(0.4, 0, 0.2, 1) 0.6s forwards' : 'none',
//                     opacity: 0
//                   }}
//                 >
//                   <Link 
//                     to="/Projects/srinivas"
//                     className="group relative bg-white text-gray-900 px-10 py-4 text-sm sm:text-base rounded-xl font-bold overflow-hidden transition-all duration-300 shadow-2xl hover:shadow-3xl transform hover:-translate-y-2"
//                   >
//                     <span className="relative z-10">Explore Projects</span>
//                     <div className="absolute inset-0 bg-gradient-to-r from-[#8B7355] to-[#6B5744] transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>
//                     <span className="absolute inset-0 flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-20">Explore Projects</span>
//                   </Link>
//                   <Link 
//                     to="/contact"
//                     className="relative bg-transparent border-2 border-white text-white px-10 py-4 text-sm sm:text-base rounded-xl font-bold backdrop-blur-sm hover:bg-white hover:text-gray-900 transition-all duration-500 hover:scale-105"
//                   >
//                     Contact Us
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           </div>
//         ))}

//         <button
//           onClick={handlePrevSlide}
//           className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 z-30 w-14 h-14 bg-white/10 backdrop-blur-md hover:bg-white/25 rounded-full flex items-center justify-center transition-all duration-300 group border border-white/20 hover:scale-110"
//         >
//           <ChevronLeft className="w-6 h-6 text-white group-hover:scale-125 transition-transform duration-300" />
//         </button>
//         <button
//           onClick={handleNextSlide}
//           className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 z-30 w-14 h-14 bg-white/10 backdrop-blur-md hover:bg-white/25 rounded-full flex items-center justify-center transition-all duration-300 group border border-white/20 hover:scale-110"
//         >
//           <ChevronRight className="w-6 h-6 text-white group-hover:scale-125 transition-transform duration-300" />
//         </button>

//         <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-30 flex space-x-3">
//           {heroSlides.map((_, index) => (
//             <button
//               key={index}
//               onClick={() => setCurrentSlide(index)}
//               className={`h-1 rounded-full transition-all duration-500 ${
//                 index === currentSlide 
//                   ? 'bg-white w-12 shadow-lg shadow-white/50' 
//                   : 'bg-white/40 w-8 hover:bg-white/60'
//               }`}
//             />
//           ))}
//         </div>

//         <div className="absolute bottom-20 left-1/2 -translate-x-1/2 z-20">
//           <div className="flex flex-col items-center animate-bounce">
//             <span className="text-white/70 text-xs mb-2 tracking-wider">SCROLL</span>
//             <ChevronDown className="w-6 h-6 text-white/70" />
//           </div>
//         </div>
//       </section>

//       {/* Who We Are Section */}
//       <section className="py-20 sm:py-28 px-4 sm:px-6 bg-white relative overflow-hidden">
//         <div className="max-w-7xl mx-auto relative z-10">
//           <div className="text-center mb-20">
//             <RevealContent>
//               <span className="text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-6 block">
//                 [WHO WE ARE]
//               </span>
//             </RevealContent>
//             <RevealContent delay={100}>
//               <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 leading-tight">
//                 Welcome to <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">Vedamsa</span>
//               </h2>
//             </RevealContent>
//             <RevealContent delay={200}>
//               <div className="max-w-4xl mx-auto">
//                 <p className="text-gray-600 text-lg sm:text-xl leading-relaxed px-4">
//                   A premier construction company in Hyderabad with a nearly <span className="font-bold text-[#8B7355]">30-year legacy</span> of excellence and trust. Over this period, Vedamsa has become synonymous with quality, reliability, and customer satisfaction in plotting and construction. With an impressive portfolio and a track record of over <span className="font-bold text-[#8B7355]">3000 happy customers</span>, we stand as a testament to what dedication, expertise, and commitment can achieve.
//                 </p>
//               </div>
//             </RevealContent>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
//             {coreValues.map((value, index) => (
//               <RevealContent key={index} delay={index * 150} direction={index === 0 ? 'left' : index === 2 ? 'right' : 'up'}>
//                 <div className="group relative bg-gradient-to-br from-[#f5f3f0] to-white p-8 rounded-2xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 border border-gray-100 overflow-hidden">
//                   <div className="absolute inset-0 bg-gradient-to-br from-[#8B7355]/5 to-[#6B5744]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  
//                   <div className="relative z-10">
//                     <div className="w-20 h-20 bg-gradient-to-br from-[#8B7355] to-[#6B5744] text-white rounded-2xl flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 group-hover:rotate-6 transition-all duration-500">
//                       {value.icon}
//                     </div>
//                     <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-[#8B7355] transition-colors duration-300">
//                       {value.title}
//                     </h3>
//                     <p className="text-gray-600 leading-relaxed">
//                       {value.description}
//                     </p>
//                   </div>

//                   <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-[#8B7355]/10 to-transparent rounded-bl-full transform translate-x-10 -translate-y-10 group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-500"></div>
//                 </div>
//               </RevealContent>
//             ))}
//           </div>

//           <RevealContent delay={450}>
//             <div className="text-center">
//               <Link 
//                 to="/about"
//                 className="group inline-flex items-center space-x-3 bg-gradient-to-r from-[#8B7355] to-[#6B5744] text-white px-10 py-5 rounded-xl font-bold hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-1 hover:scale-105 relative overflow-hidden"
//               >
//                 <span className="relative z-10">Know More</span>
//                 <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300 relative z-10" />
//                 <div className="absolute inset-0 bg-gradient-to-r from-[#6B5744] to-[#8B7355] opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
//               </Link>
//             </div>
//           </RevealContent>
//         </div>
//       </section>

//       {/* Projects Section with SILVER Reveals */}
//    <section className="py-20 sm:py-28 px-4 sm:px-6 bg-gradient-to-b from-[#f5f3f0] to-white relative overflow-hidden">
//   <div className="max-w-7xl mx-auto relative z-10">
//     <div className="text-center mb-20">
//       <RevealContent>
//         <span className="text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-6 block">
//           [OUR PROJECTS]
//         </span>
//       </RevealContent>
//       <RevealContent delay={100}>
//         <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 leading-tight px-4">
//           Creating Environments that<br className="hidden sm:block" />
//           <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">Inspire and Delight</span>
//         </h2>
//       </RevealContent>
//     </div>

//     <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
//       <RevealContent delay={100}>
//         <Link 
//           to="/Projects/srinivas"
//           className="group relative overflow-hidden rounded-3xl shadow-2xl hover:shadow-3xl transition-all duration-700 block transform hover:scale-[1.02]"
//         >
//           <div className="relative aspect-square overflow-hidden">
//             <RevealImage 
//               src={post2}
//               alt="MAA Srinivasam"
//               className="w-full h-full object-cover"
//             />
            
//             <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-80 group-hover:opacity-70 transition-opacity duration-500"></div>
            
//             <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
//           </div>
          
//           <div className="absolute bottom-0 left-0 right-0 p-8 text-white transform group-hover:translate-y-0 transition-transform duration-500">
//             <span className="inline-block text-xs uppercase tracking-wider text-white/90 mb-3 px-4 py-1 bg-white/20 backdrop-blur-sm rounded-full">
//               Luxury Apartments
//             </span>
//             <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 group-hover:tracking-wide transition-all duration-500">
//               MAA Srinivasam
//             </h3>
//             <p className="text-white/90 mb-2 text-lg">Gated Community Apartment Project</p>
//             <p className="text-white/80 mb-6">2 & 3 BHK Premium Apartments in Isnapur, Mumbai Highway</p>
//             <div className="inline-flex items-center space-x-2 bg-white text-gray-900 px-8 py-4 rounded-xl font-semibold group-hover:bg-[#8B7355] group-hover:text-white transition-all duration-500 transform group-hover:scale-105">
//               <span>View Project</span>
//               <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" />
//             </div>
//           </div>
//         </Link>
//       </RevealContent>

//       <RevealContent delay={250}>
//         <Link 
//           to="/Projects/garudadri"
//           className="group relative overflow-hidden rounded-3xl shadow-2xl hover:shadow-3xl transition-all duration-700 block transform hover:scale-[1.02]"
//         >
//           <div className="relative aspect-square overflow-hidden">
//             <RevealImage 
//               src={post1}
//               alt="MAA Garudadri"
//               className="w-full h-full object-cover"
//             />
            
//             <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-80 group-hover:opacity-70 transition-opacity duration-500"></div>
            
//             <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
//           </div>
          
//           <div className="absolute bottom-0 left-0 right-0 p-8 text-white transform group-hover:translate-y-0 transition-transform duration-500">
//             <span className="inline-block text-xs uppercase tracking-wider text-white/90 mb-3 px-4 py-1 bg-white/20 backdrop-blur-sm rounded-full">
//               Villa Plots
//             </span>
//             <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 group-hover:tracking-wide transition-all duration-500">
//               MAA Garudadri
//             </h3>
//             <p className="text-white/90 mb-2 text-lg">Villa and Open Plot Project</p>
//             <p className="text-white/80 mb-6">Premium Villa Plots in Dandupally, Nagpur Highway</p>
//             <div className="inline-flex items-center space-x-2 bg-white text-gray-900 px-8 py-4 rounded-xl font-semibold group-hover:bg-[#2C5F2D] group-hover:text-white transition-all duration-500 transform group-hover:scale-105">
//               <span>View Project</span>
//               <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" />
//             </div>
//           </div>
//         </Link>
//       </RevealContent>
//     </div>
//   </div>
// </section>

//       {/* Stats Section */}
//       <section className="py-20 sm:py-28 px-4 sm:px-6 bg-gray-900 text-white relative overflow-hidden">
//         <div className="absolute inset-0 opacity-10"
//           style={{
//             backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255,255,255,0.03) 10px, rgba(255,255,255,0.03) 20px)',
//           }}
//         ></div>

//         <div className="max-w-7xl mx-auto relative z-10">
//           <div className="text-center mb-20">
//             <RevealContent>
//               <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6">
//                 Design A <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#C0C0C0]">Dynamic Future</span>
//               </h2>
//             </RevealContent>
//             <RevealContent delay={100}>
//               <p className="text-gray-300 text-xl">Experience Excellence</p>
//             </RevealContent>
//           </div>

//           <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
//             {stats.map((stat, index) => (
//               <RevealContent key={index} delay={index * 100} direction={index % 2 === 0 ? 'up' : 'down'}>
//                 <div className="text-center transform hover:scale-110 transition-all duration-500 group">
//                   <div className="relative inline-block">
//                     <div className="text-5xl sm:text-6xl md:text-7xl font-bold mb-2 bg-clip-text text-transparent bg-gradient-to-br from-[#8B7355] via-[#C0C0C0] to-[#E8E8E8] group-hover:scale-110 transition-transform duration-500">
//                       {stat.number}
//                     </div>
//                     <div className="absolute inset-0 blur-2xl bg-[#8B7355]/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
//                   </div>
//                   <div className="text-gray-400 text-sm sm:text-base group-hover:text-gray-200 transition-colors duration-300">
//                     {stat.text}
//                   </div>
//                 </div>
//               </RevealContent>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Testimonials Section */}
//       <section className="py-20 sm:py-28 px-4 sm:px-6 bg-white relative overflow-hidden">
//         <div className="max-w-7xl mx-auto relative z-10">
//           <div className="text-center mb-20">
//             <RevealContent>
//               <span className="text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-6 block">
//                 [TESTIMONIALS]
//               </span>
//             </RevealContent>
//             <RevealContent delay={100}>
//               <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6">
//                 What <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">People Say</span>
//               </h2>
//             </RevealContent>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {testimonials.map((testimonial, index) => (
//               <RevealContent key={index} delay={index * 150} direction={index % 3 === 0 ? 'left' : index % 3 === 1 ? 'up' : 'right'}>
//                 <div className="group relative bg-gradient-to-br from-[#f5f3f0] to-white p-8 rounded-2xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100 overflow-hidden">
//                   <div className="absolute top-4 right-4 text-[#8B7355]/10 text-8xl font-serif">"</div>
                  
//                   <div className="relative z-10">
//                     <div className="flex mb-6">
//                       {[...Array(testimonial.rating)].map((_, i) => (
//                         <Star 
//                           key={i} 
//                           className="w-5 h-5 fill-yellow-400 text-yellow-400 transform group-hover:scale-110 transition-transform duration-300"
//                           style={{ transitionDelay: `${i * 50}ms` }}
//                         />
//                       ))}
//                     </div>
//                     <p className="text-gray-700 leading-relaxed mb-6 italic text-lg">
//                       "{testimonial.text}"
//                     </p>
//                     <div className="flex items-center">
//                       <div className="w-12 h-12 bg-gradient-to-br from-[#8B7355] to-[#6B5744] rounded-full flex items-center justify-center mr-4 text-white font-bold">
//                         {testimonial.name.charAt(0)}
//                       </div>
//                       <div>
//                         <p className="font-bold text-gray-900">{testimonial.name}</p>
//                         <p className="text-sm text-gray-600">{testimonial.role}</p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </RevealContent>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="relative py-32 sm:py-40 px-4 sm:px-6 overflow-hidden">
//         <div 
//           className="absolute inset-0 bg-cover bg-center bg-fixed"
//           style={{
//             backgroundImage: `url('https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1920')`,
//           }}
//         ></div>
//         <div className="absolute inset-0 bg-gradient-to-r from-[#8B7355]/95 to-[#6B5744]/90"></div>
        
//         <div 
//           className="absolute inset-0 opacity-10"
//           style={{
//             backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
//             backgroundSize: '50px 50px',
//             animation: 'movePattern 20s linear infinite'
//           }}
//         ></div>

//         <div className="relative z-10 max-w-4xl mx-auto text-center text-white">
//           <RevealContent>
//             <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6">
//               Book Your <span className="italic">Dream Home</span>
//             </h2>
//           </RevealContent>
//           <RevealContent delay={100}>
//             <p className="text-xl sm:text-2xl text-white/90 mb-12 px-4 leading-relaxed">
//               Find the perfect place to call home! Reserve your dream home now and step into a life of comfort, luxury, and style.
//             </p>
//           </RevealContent>

//           <RevealContent delay={200}>
//             <Link 
//               to="/contact"
//               className="group inline-flex items-center space-x-3 bg-white text-gray-900 px-12 py-6 rounded-xl font-bold hover:bg-gradient-to-r hover:from-[#C0C0C0] hover:to-[#E8E8E8] transition-all duration-500 shadow-2xl hover:shadow-3xl transform hover:-translate-y-2 hover:scale-105 text-lg relative overflow-hidden"
//             >
//               <span className="relative z-10">Contact Us</span>
//               <ArrowRight className="w-6 h-6 group-hover:translate-x-2 transition-transform duration-300 relative z-10" />
//             </Link>
//           </RevealContent>

//           <RevealContent delay={300}>
//             <div className="mt-16 pt-16 border-t border-white/30">
//               <div className="flex flex-col sm:flex-row gap-8 justify-center text-white">
//                 <a 
//                   href="tel:8885852266" 
//                   className="group flex items-center justify-center space-x-3 hover:text-white/80 transition-all duration-300 text-lg"
//                 >
//                   <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
//                     <Phone className="w-6 h-6" />
//                   </div>
//                   <span>8885852266</span>
//                 </a>
//                 <a 
//                   href="mailto:Vedamsa@gmail.com" 
//                   className="group flex items-center justify-center space-x-3 hover:text-white/80 transition-all duration-300 text-lg"
//                 >
//                   <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
//                     <Mail className="w-6 h-6" />
//                   </div>
//                   <span>Vedamsa@gmail.com</span>
//                 </a>
//               </div>
//             </div>
//           </RevealContent>
//         </div>
//       </section>

//       {/* Footer */}
//       {/* <footer className="bg-[#1a1410] text-white py-12 px-4 sm:px-6 relative overflow-hidden">
//         <div 
//           className="absolute inset-0 opacity-5"
//           style={{
//             backgroundImage: 'linear-gradient(30deg, #8B7355 12%, transparent 12.5%, transparent 87%, #8B7355 87.5%)',
//             backgroundSize: '80px 140px'
//           }}
//         ></div>

//         <div className="max-w-7xl mx-auto relative z-10">
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mb-8">
//             <div>
//               <div className="flex items-center space-x-3 mb-4">
//                 <div className="bg-gradient-to-br from-[#8B7355] to-[#6B5744] text-white p-2 rounded-lg shadow-lg">
//                   <Building2 className="w-6 h-6" />
//                 </div>
//                 <span className="text-2xl font-bold">Vedamsa</span>
//               </div>
//               <p className="text-gray-400 mb-4">Building Dreams, Creating Futures</p>
//               <p className="text-gray-500 text-sm">Turn your dream of owning a home into reality with Vedamsa Infra</p>
//             </div>

//             <div>
//               <h4 className="font-bold mb-4 text-lg">Quick Links</h4>
//               <div className="space-y-3 text-gray-400">
//                 <Link to="/" className="block hover:text-white hover:translate-x-2 transition-all duration-300">→ Home</Link>
//                 <Link to="/about" className="block hover:text-white hover:translate-x-2 transition-all duration-300">→ About</Link>
//                 <Link to="/maa-srinivasam" className="block hover:text-white hover:translate-x-2 transition-all duration-300">→ MAA Srinivasam</Link>
//                 <Link to="/maa-garudadri" className="block hover:text-white hover:translate-x-2 transition-all duration-300">→ MAA Garudadri</Link>
//                 <Link to="/contact" className="block hover:text-white hover:translate-x-2 transition-all duration-300">→ Contact</Link>
//               </div>
//             </div>

//             <div>
//               <h4 className="font-bold mb-4 text-lg">Contact</h4>
//               <div className="space-y-3 text-gray-400">
//                 <p>Hyderabad, Telangana</p>
//                 <p>Phone: 8885852266</p>
//                 <p>Email: Vedamsa@gmail.com</p>
//               </div>
//             </div>
//           </div>

//           <div className="border-t border-gray-800 pt-8 text-center">
//             <p className="text-gray-500 text-sm">
//               Copyright © 2025 Vedamsa. All rights reserved.
//             </p>
//           </div>
//         </div>
//       </footer> */}

//       <style jsx>{`
//         @keyframes popupEntrance {
//           0% {
//             opacity: 0;
//             transform: scale(0.8) translateY(30px);
//           }
//           100% {
//             opacity: 1;
//             transform: scale(1) translateY(0);
//           }
//         }

//         @keyframes fadeSlideDown {
//           from {
//             opacity: 0;
//             transform: translateY(-40px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         @keyframes fadeSlideUp {
//           from {
//             opacity: 0;
//             transform: translateY(40px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         @keyframes movePattern {
//           0% {
//             transform: translate(0, 0);
//           }
//           100% {
//             transform: translate(50px, 50px);
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default HomePage;


import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { 
  ChevronDown, 
  ChevronLeft, 
  ChevronRight,
  Building2,
  Award,
  TrendingUp,
  Phone,
  Mail,
  X,
  ArrowRight,
  Star,
  CheckCircle
} from 'lucide-react';
import srinivas from  './Images/1-FRONT-1-scaled-1.jpg';
import garudadri from  './Images/garuda.png';
import post1 from './Images/vedamsa-post-10.png';
import post2 from './Images/Poster-2.png';

// PURE SILVER Reveal Image Component
const RevealImage = ({ src, alt, className = "" }) => {
  const wrapperRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = wrapperRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsRevealed(true);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.2 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);
  
  return (
    <div ref={wrapperRef} className={`relative overflow-hidden ${className}`}>
      <img 
        src={src} 
        alt={alt} 
        className={`w-full h-full object-cover relative z-[1] transition-all duration-[1500ms] ease-out ${
          isRevealed ? 'opacity-100 scale-100 blur-0' : 'opacity-0 scale-110 blur-sm'
        }`}
        style={{ transitionDelay: '800ms' }}
      />
      
      {/* PURE SILVER Gradient Mask */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[2] transition-transform duration-[1500ms] ${
          isRevealed ? 'scale-x-0 origin-right' : 'scale-x-100 origin-left'
        }`}
        style={{ 
          transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)',
          background: 'linear-gradient(90deg, #C0C0C0 0%, #E8E8E8 25%, #FFFFFF 50%, #E8E8E8 75%, #C0C0C0 100%)'
        }}
      />
      
      {/* Silver Shimmer */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[3] transition-all duration-[1500ms] ${
          isRevealed ? 'opacity-0 translate-x-full' : 'opacity-100 translate-x-0'
        }`}
        style={{ 
          transitionDelay: '300ms',
          background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.8) 50%, transparent 100%)',
          transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)'
        }}
      />
    </div>
  );
};

const RevealContent = ({ children, className = "", delay = 0, direction = 'up' }) => {
  const contentRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = contentRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              setIsRevealed(true);
            }, delay);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.15 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, [delay]);
  
  const getTransform = () => {
    if (direction === 'up') return isRevealed ? 'translate-y-0' : 'translate-y-[60px]';
    if (direction === 'down') return isRevealed ? 'translate-y-0' : '-translate-y-[60px]';
    if (direction === 'left') return isRevealed ? 'translate-x-0' : 'translate-x-[60px]';
    if (direction === 'right') return isRevealed ? 'translate-x-0' : '-translate-x-[60px]';
    return '';
  };
  
  return (
    <div 
      ref={contentRef} 
      className={`transition-all duration-1000 ${
        isRevealed ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
      } ${getTransform()} ${className}`}
      style={{ transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)' }}
    >
      {children}
    </div>
  );
};

const HomePage = () => {
  const [scrolled, setScrolled] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: ''
  });

  const heroSlides = [
    {
      image: srinivas,
      title: 'Creating Spaces',
      subtitle: 'That Inspire',
      description: 'Transforming visions into architectural masterpieces with precision and creativity'
    },
    {
      image: garudadri,
      title: 'Building Dreams',
      subtitle: 'Creating Futures',
      description: '30 years of excellence in Hyderabad real estate with over 3000 happy customers'
    }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev === heroSlides.length - 1 ? 0 : prev + 1));
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  const handlePrevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? heroSlides.length - 1 : prev - 1));
  };

  const handleNextSlide = () => {
    setCurrentSlide((prev) => (prev === heroSlides.length - 1 ? 0 : prev + 1));
  };

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    
    // Validate phone number (basic validation)
    if (!formData.phone || formData.phone.length < 10) {
      alert('Please enter a valid phone number');
      return;
    }

    // Create WhatsApp message
    const message = encodeURIComponent(
      `Hello! I'm ${formData.name}.\n\nI'm interested in learning more about Vedamsa Infrastructure projects.\n\nMy contact number: ${formData.phone}\n\nPlease get in touch with me.`
    );
    
    // WhatsApp number (replace with your actual WhatsApp business number)
    const whatsappNumber = '918885852266'; // Format: country code + number (no + or spaces)
    
    // Detect if mobile or desktop
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    // Create WhatsApp URL
    const whatsappURL = isMobile 
      ? `whatsapp://send?phone=${whatsappNumber}&text=${message}`
      : `https://web.whatsapp.com/send?phone=${whatsappNumber}&text=${message}`;
    
    // Close popup
    setShowPopup(false);
    
    // Open WhatsApp
    window.open(whatsappURL, '_blank');
    
    // Reset form
    setFormData({ name: '', phone: '' });
  };

  const stats = [
    { number: '30+', text: 'Years of Experience' },
    { number: '70+', text: 'Projects Completed' },
    { number: '3,000+', text: 'Happy Customers' },
    { number: '2', text: 'Upcoming Projects' }
  ];

  const coreValues = [
    {
      icon: <Award className="w-8 h-8" />,
      title: 'Quality',
      description: 'We use the finest materials and employ stringent quality control measures to ensure that every project we undertake meets the highest standards of excellence.'
    },
    {
      icon: <TrendingUp className="w-8 h-8" />,
      title: 'Innovation',
      description: 'We embrace new technologies and innovative construction methods to deliver projects that are aesthetically pleasing but also sustainable and durable.'
    },
    {
      icon: <CheckCircle className="w-8 h-8" />,
      title: 'Transparency',
      description: 'We maintain open and honest communication with our clients, ensuring they are informed and involved at every stage of the construction process.'
    }
  ];

  const testimonials = [
    {
      name: 'Suresh Varma',
      role: 'Builder',
      text: 'Vedamsa exceeded our expectations in every way. Their projects are best in quality and delivered on time',
      rating: 5
    },
    {
      name: 'Venkat Chowdary',
      role: 'Developer',
      text: 'Choosing Vedamsa for our new apartment was the best decision we made. Their sales team is very supportive and helpful.',
      rating: 5
    },
    {
      name: 'Supriya',
      role: 'IT Employee',
      text: 'The experience with Vedamsa has been exceptional. Their commitment to quality and customer satisfaction is evident in every aspect of their work.',
      rating: 5
    }
  ];

  return (
    <div className="min-h-screen bg-[#f5f3f0] overflow-x-hidden">
      {/* Popup Form */}
      {showPopup && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 backdrop-blur-md px-4">
          <div 
            className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-6 sm:p-8 relative transform transition-all duration-700 ease-out"
            style={{
              animation: 'popupEntrance 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) forwards'
            }}
          >
            <button
              onClick={() => setShowPopup(false)}
              className="absolute top-3 right-3 sm:top-4 sm:right-4 w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-all duration-300 hover:rotate-90 group"
            >
              <X className="w-5 h-5 text-gray-600 group-hover:text-gray-900" />
            </button>

            <div className="text-center mb-6">
              <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-[#8B7355] to-[#6B5744] rounded-full flex items-center justify-center mx-auto mb-4 shadow-xl transform hover:scale-110 transition-transform duration-300">
                <Building2 className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
              </div>
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2 bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">
                Get Exclusive Updates!
              </h3>
              <p className="text-sm sm:text-base text-gray-600">Be the first to know about our latest projects and offers</p>
            </div>

            <form onSubmit={handleFormSubmit} className="space-y-4">
              <div className="group">
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">Full Name *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleFormChange}
                  required
                  placeholder="Enter your name"
                  className="w-full px-4 py-3 text-sm sm:text-base border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-[#8B7355] focus:border-[#8B7355] outline-none transition-all duration-300 hover:border-[#8B7355]/50"
                />
              </div>

              <div className="group">
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">Phone Number *</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleFormChange}
                  required
                  placeholder="Enter your phone number"
                  pattern="[0-9]{10}"
                  maxLength="10"
                  className="w-full px-4 py-3 text-sm sm:text-base border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-[#8B7355] focus:border-[#8B7355] outline-none transition-all duration-300 hover:border-[#8B7355]/50"
                />
              </div>

              <button
                type="submit"
                className="w-full bg-gradient-to-r from-[#25D366] to-[#128C7E] text-white px-6 py-4 rounded-xl font-bold hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-[1.02] relative overflow-hidden group flex items-center justify-center gap-2"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                <span className="relative z-10">Continue on WhatsApp</span>
                <div className="absolute inset-0 bg-gradient-to-r from-[#128C7E] to-[#25D366] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </button>

              <p className="text-xs text-gray-500 text-center">
                We respect your privacy. Your information is safe with us.
              </p>
            </form>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <section className="relative h-screen w-full overflow-hidden">
        {heroSlides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-all duration-[2000ms] ease-in-out ${
              index === currentSlide ? 'opacity-100 scale-100' : 'opacity-0 scale-105'
            }`}
          >
            <div 
              className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-[8000ms] ease-out"
              style={{
                backgroundImage: `url('${slide.image}')`,
                backgroundPosition: 'center top',
                transform: index === currentSlide ? 'scale(1.1)' : 'scale(1)',
              }}
            ></div>
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
            
            <div 
              className="absolute inset-0 opacity-10"
              style={{
                backgroundImage: 'radial-gradient(circle at 20% 50%, white 1px, transparent 1px), radial-gradient(circle at 80% 80%, white 1px, transparent 1px)',
                backgroundSize: '50px 50px',
                animation: 'movePattern 20s linear infinite'
              }}
            ></div>
            
            <div className="relative z-20 h-full flex items-center justify-center pt-16 sm:pt-20">
              <div className="text-center px-4 sm:px-6 max-w-5xl mx-auto">
                <div 
                  className="mb-6 inline-block"
                  style={{
                    animation: index === currentSlide ? 'fadeSlideDown 1.2s cubic-bezier(0.4, 0, 0.2, 1) forwards' : 'none',
                    opacity: 0
                  }}
                >
                  <span className="text-white/90 text-xs sm:text-sm uppercase tracking-[0.3em] font-light border border-white/30 px-6 py-2 rounded-full backdrop-blur-sm">
                    Vedamsa Infrastructure
                  </span>
                </div>
                
                <h1 
                  className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl font-light text-white mb-4 leading-tight"
                  style={{
                    animation: index === currentSlide ? 'fadeSlideUp 1.4s cubic-bezier(0.4, 0, 0.2, 1) 0.2s forwards' : 'none',
                    opacity: 0,
                    textShadow: '0 10px 30px rgba(0,0,0,0.5)'
                  }}
                >
                  {slide.title}<br />
                  <span className="font-light italic bg-clip-text text-transparent bg-gradient-to-r from-white via-gray-200 to-white">
                    {slide.subtitle}
                  </span>
                </h1>
                
                <p 
                  className="text-white/90 text-lg sm:text-xl md:text-2xl mb-12 max-w-3xl mx-auto leading-relaxed px-4"
                  style={{
                    animation: index === currentSlide ? 'fadeSlideUp 1.6s cubic-bezier(0.4, 0, 0.2, 1) 0.4s forwards' : 'none',
                    opacity: 0
                  }}
                >
                  {slide.description}
                </p>
                
                <div 
                  className="flex flex-col sm:flex-row gap-4 justify-center px-4"
                  style={{
                    animation: index === currentSlide ? 'fadeSlideUp 1.8s cubic-bezier(0.4, 0, 0.2, 1) 0.6s forwards' : 'none',
                    opacity: 0
                  }}
                >
                  <Link 
                    to="/Projects/srinivas"
                    className="group relative bg-white text-gray-900 px-10 py-4 text-sm sm:text-base rounded-xl font-bold overflow-hidden transition-all duration-300 shadow-2xl hover:shadow-3xl transform hover:-translate-y-2"
                  >
                    <span className="relative z-10">Explore Projects</span>
                    <div className="absolute inset-0 bg-gradient-to-r from-[#8B7355] to-[#6B5744] transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>
                    <span className="absolute inset-0 flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-20">Explore Projects</span>
                  </Link>
                  <Link 
                    to="/contact"
                    className="relative bg-transparent border-2 border-white text-white px-10 py-4 text-sm sm:text-base rounded-xl font-bold backdrop-blur-sm hover:bg-white hover:text-gray-900 transition-all duration-500 hover:scale-105"
                  >
                    Contact Us
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}

        <button
          onClick={handlePrevSlide}
          className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 z-30 w-14 h-14 bg-white/10 backdrop-blur-md hover:bg-white/25 rounded-full flex items-center justify-center transition-all duration-300 group border border-white/20 hover:scale-110"
        >
          <ChevronLeft className="w-6 h-6 text-white group-hover:scale-125 transition-transform duration-300" />
        </button>
        <button
          onClick={handleNextSlide}
          className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 z-30 w-14 h-14 bg-white/10 backdrop-blur-md hover:bg-white/25 rounded-full flex items-center justify-center transition-all duration-300 group border border-white/20 hover:scale-110"
        >
          <ChevronRight className="w-6 h-6 text-white group-hover:scale-125 transition-transform duration-300" />
        </button>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-30 flex space-x-3">
          {heroSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`h-1 rounded-full transition-all duration-500 ${
                index === currentSlide 
                  ? 'bg-white w-12 shadow-lg shadow-white/50' 
                  : 'bg-white/40 w-8 hover:bg-white/60'
              }`}
            />
          ))}
        </div>

        <div className="absolute bottom-20 left-1/2 -translate-x-1/2 z-20">
          <div className="flex flex-col items-center animate-bounce">
            <span className="text-white/70 text-xs mb-2 tracking-wider">SCROLL</span>
            <ChevronDown className="w-6 h-6 text-white/70" />
          </div>
        </div>
      </section>

      {/* Rest of the sections remain the same... */}
      {/* Who We Are Section */}
      <section className="py-20 sm:py-28 px-4 sm:px-6 bg-white relative overflow-hidden">
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center mb-20">
            <RevealContent>
              <span className="text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-6 block">
                [WHO WE ARE]
              </span>
            </RevealContent>
            <RevealContent delay={100}>
              <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 leading-tight">
                Welcome to <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">Vedamsa</span>
              </h2>
            </RevealContent>
            <RevealContent delay={200}>
              <div className="max-w-4xl mx-auto">
                <p className="text-gray-600 text-lg sm:text-xl leading-relaxed px-4">
                  A premier construction company in Hyderabad with a nearly <span className="font-bold text-[#8B7355]">30-year legacy</span> of excellence and trust. Over this period, Vedamsa has become synonymous with quality, reliability, and customer satisfaction in plotting and construction. With an impressive portfolio and a track record of over <span className="font-bold text-[#8B7355]">3000 happy customers</span>, we stand as a testament to what dedication, expertise, and commitment can achieve.
                </p>
              </div>
            </RevealContent>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {coreValues.map((value, index) => (
              <RevealContent key={index} delay={index * 150} direction={index === 0 ? 'left' : index === 2 ? 'right' : 'up'}>
                <div className="group relative bg-gradient-to-br from-[#f5f3f0] to-white p-8 rounded-2xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 border border-gray-100 overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-br from-[#8B7355]/5 to-[#6B5744]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  
                  <div className="relative z-10">
                    <div className="w-20 h-20 bg-gradient-to-br from-[#8B7355] to-[#6B5744] text-white rounded-2xl flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 group-hover:rotate-6 transition-all duration-500">
                      {value.icon}
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-[#8B7355] transition-colors duration-300">
                      {value.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {value.description}
                    </p>
                  </div>

                  <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-[#8B7355]/10 to-transparent rounded-bl-full transform translate-x-10 -translate-y-10 group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-500"></div>
                </div>
              </RevealContent>
            ))}
          </div>

          <RevealContent delay={450}>
            <div className="text-center">
              <Link 
                to="/about"
                className="group inline-flex items-center space-x-3 bg-gradient-to-r from-[#8B7355] to-[#6B5744] text-white px-10 py-5 rounded-xl font-bold hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-1 hover:scale-105 relative overflow-hidden"
              >
                <span className="relative z-10">Know More</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300 relative z-10" />
                <div className="absolute inset-0 bg-gradient-to-r from-[#6B5744] to-[#8B7355] opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </Link>
            </div>
          </RevealContent>
        </div>
      </section>

      {/* Projects Section with SILVER Reveals */}
   <section className="py-20 sm:py-28 px-4 sm:px-6 bg-gradient-to-b from-[#f5f3f0] to-white relative overflow-hidden">
  <div className="max-w-7xl mx-auto relative z-10">
    <div className="text-center mb-20">
      <RevealContent>
        <span className="text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-6 block">
          [OUR PROJECTS]
        </span>
      </RevealContent>
      <RevealContent delay={100}>
        <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 leading-tight px-4">
          Creating Environments that<br className="hidden sm:block" />
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">Inspire and Delight</span>
        </h2>
      </RevealContent>
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
      <RevealContent delay={100}>
        <Link 
          to="/Projects/srinivas"
          className="group relative overflow-hidden rounded-3xl shadow-2xl hover:shadow-3xl transition-all duration-700 block transform hover:scale-[1.02]"
        >
          <div className="relative aspect-square overflow-hidden">
            <RevealImage 
              src={post2}
              alt="MAA Srinivasam"
              className="w-full h-full object-cover"
            />
            
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-80 group-hover:opacity-70 transition-opacity duration-500"></div>
            
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
          </div>
          
          <div className="absolute bottom-0 left-0 right-0 p-8 text-white transform group-hover:translate-y-0 transition-transform duration-500">
            <span className="inline-block text-xs uppercase tracking-wider text-white/90 mb-3 px-4 py-1 bg-white/20 backdrop-blur-sm rounded-full">
              Luxury Apartments
            </span>
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 group-hover:tracking-wide transition-all duration-500">
              MAA Srinivasam
            </h3>
            <p className="text-white/90 mb-2 text-lg">Gated Community Apartment Project</p>
            <p className="text-white/80 mb-6">2 & 3 BHK Premium Apartments in Isnapur, Mumbai Highway</p>
            <div className="inline-flex items-center space-x-2 bg-white text-gray-900 px-8 py-4 rounded-xl font-semibold group-hover:bg-[#8B7355] group-hover:text-white transition-all duration-500 transform group-hover:scale-105">
              <span>View Project</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" />
            </div>
          </div>
        </Link>
      </RevealContent>

      <RevealContent delay={250}>
        <Link 
          to="/Projects/garudadri"
          className="group relative overflow-hidden rounded-3xl shadow-2xl hover:shadow-3xl transition-all duration-700 block transform hover:scale-[1.02]"
        >
          <div className="relative aspect-square overflow-hidden">
            <RevealImage 
              src={post1}
              alt="MAA Garudadri"
              className="w-full h-full object-cover"
            />
            
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-80 group-hover:opacity-70 transition-opacity duration-500"></div>
            
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
          </div>
          
          <div className="absolute bottom-0 left-0 right-0 p-8 text-white transform group-hover:translate-y-0 transition-transform duration-500">
            <span className="inline-block text-xs uppercase tracking-wider text-white/90 mb-3 px-4 py-1 bg-white/20 backdrop-blur-sm rounded-full">
              Villa Plots
            </span>
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 group-hover:tracking-wide transition-all duration-500">
              MAA Garudadri
            </h3>
            <p className="text-white/90 mb-2 text-lg">Villa and Open Plot Project</p>
            <p className="text-white/80 mb-6">Premium Villa Plots in Dandupally, Nagpur Highway</p>
            <div className="inline-flex items-center space-x-2 bg-white text-gray-900 px-8 py-4 rounded-xl font-semibold group-hover:bg-[#2C5F2D] group-hover:text-white transition-all duration-500 transform group-hover:scale-105">
              <span>View Project</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" />
            </div>
          </div>
        </Link>
      </RevealContent>
    </div>
  </div>
</section>

      {/* Stats Section */}
      <section className="py-20 sm:py-28 px-4 sm:px-6 bg-gray-900 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255,255,255,0.03) 10px, rgba(255,255,255,0.03) 20px)',
          }}
        ></div>

        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center mb-20">
            <RevealContent>
              <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6">
                Design A <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#C0C0C0]">Dynamic Future</span>
              </h2>
            </RevealContent>
            <RevealContent delay={100}>
              <p className="text-gray-300 text-xl">Experience Excellence</p>
            </RevealContent>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <RevealContent key={index} delay={index * 100} direction={index % 2 === 0 ? 'up' : 'down'}>
                <div className="text-center transform hover:scale-110 transition-all duration-500 group">
                  <div className="relative inline-block">
                    <div className="text-5xl sm:text-6xl md:text-7xl font-bold mb-2 bg-clip-text text-transparent bg-gradient-to-br from-[#8B7355] via-[#C0C0C0] to-[#E8E8E8] group-hover:scale-110 transition-transform duration-500">
                      {stat.number}
                    </div>
                    <div className="absolute inset-0 blur-2xl bg-[#8B7355]/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  </div>
                  <div className="text-gray-400 text-sm sm:text-base group-hover:text-gray-200 transition-colors duration-300">
                    {stat.text}
                  </div>
                </div>
              </RevealContent>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 sm:py-28 px-4 sm:px-6 bg-white relative overflow-hidden">
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center mb-20">
            <RevealContent>
              <span className="text-sm uppercase tracking-[0.3em] text-[#8B7355] font-bold mb-6 block">
                [TESTIMONIALS]
              </span>
            </RevealContent>
            <RevealContent delay={100}>
              <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 mb-6">
                What <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#8B7355] to-[#6B5744]">People Say</span>
              </h2>
            </RevealContent>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <RevealContent key={index} delay={index * 150} direction={index % 3 === 0 ? 'left' : index % 3 === 1 ? 'up' : 'right'}>
                <div className="group relative bg-gradient-to-br from-[#f5f3f0] to-white p-8 rounded-2xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100 overflow-hidden">
                  <div className="absolute top-4 right-4 text-[#8B7355]/10 text-8xl font-serif">"</div>
                  
                  <div className="relative z-10">
                    <div className="flex mb-6">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <Star 
                          key={i} 
                          className="w-5 h-5 fill-yellow-400 text-yellow-400 transform group-hover:scale-110 transition-transform duration-300"
                          style={{ transitionDelay: `${i * 50}ms` }}
                        />
                      ))}
                    </div>
                    <p className="text-gray-700 leading-relaxed mb-6 italic text-lg">
                      "{testimonial.text}"
                    </p>
                    <div className="flex items-center">
                      <div className="w-12 h-12 bg-gradient-to-br from-[#8B7355] to-[#6B5744] rounded-full flex items-center justify-center mr-4 text-white font-bold">
                        {testimonial.name.charAt(0)}
                      </div>
                      <div>
                        <p className="font-bold text-gray-900">{testimonial.name}</p>
                        <p className="text-sm text-gray-600">{testimonial.role}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </RevealContent>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-32 sm:py-40 px-4 sm:px-6 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-fixed"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1920')`,
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-[#8B7355]/95 to-[#6B5744]/90"></div>
        
        <div 
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
            backgroundSize: '50px 50px',
            animation: 'movePattern 20s linear infinite'
          }}
        ></div>

        <div className="relative z-10 max-w-4xl mx-auto text-center text-white">
          <RevealContent>
            <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6">
              Book Your <span className="italic">Dream Home</span>
            </h2>
          </RevealContent>
          <RevealContent delay={100}>
            <p className="text-xl sm:text-2xl text-white/90 mb-12 px-4 leading-relaxed">
              Find the perfect place to call home! Reserve your dream home now and step into a life of comfort, luxury, and style.
            </p>
          </RevealContent>

          <RevealContent delay={200}>
            <Link 
              to="/contact"
              className="group inline-flex items-center space-x-3 bg-white text-gray-900 px-12 py-6 rounded-xl font-bold hover:bg-gradient-to-r hover:from-[#C0C0C0] hover:to-[#E8E8E8] transition-all duration-500 shadow-2xl hover:shadow-3xl transform hover:-translate-y-2 hover:scale-105 text-lg relative overflow-hidden"
            >
              <span className="relative z-10">Contact Us</span>
              <ArrowRight className="w-6 h-6 group-hover:translate-x-2 transition-transform duration-300 relative z-10" />
            </Link>
          </RevealContent>

          <RevealContent delay={300}>
            <div className="mt-16 pt-16 border-t border-white/30">
              <div className="flex flex-col sm:flex-row gap-8 justify-center text-white">
                <a 
                  href="tel:8885852266" 
                  className="group flex items-center justify-center space-x-3 hover:text-white/80 transition-all duration-300 text-lg"
                >
                  <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <Phone className="w-6 h-6" />
                  </div>
                  <span>8885852266</span>
                </a>
                <a 
                  href="mailto:Vedamsa@gmail.com" 
                  className="group flex items-center justify-center space-x-3 hover:text-white/80 transition-all duration-300 text-lg"
                >
                  <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <Mail className="w-6 h-6" />
                  </div>
                  <span>Vedamsa@gmail.com</span>
                </a>
              </div>
            </div>
          </RevealContent>
        </div>
      </section>

      <style jsx>{`
        @keyframes popupEntrance {
          0% {
            opacity: 0;
            transform: scale(0.8) translateY(30px);
          }
          100% {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        @keyframes fadeSlideDown {
          from {
            opacity: 0;
            transform: translateY(-40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeSlideUp {
          from {
            opacity: 0;
            transform: translateY(40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes movePattern {
          0% {
            transform: translate(0, 0);
          }
          100% {
            transform: translate(50px, 50px);
          }
        }
      `}</style>
    </div>
  );
};

export default HomePage;
